import axios from 'axios';
import {toast} from "vue3-toastify";

const productModule = {
    namespaced: true,
    state() {
        return {
            productLoading: false,
            products: [],
            productReview: [],
            reviewLoading :false,
            pagination:null,
            addToCartLoading:false,
        };
    },
    mutations: {
        SET_PRODUCT_SHIMMER(state, loading) {
            state.productLoading = loading;
        },
        SET_PRODUCT_DATA(state, data) {
            state.products = data;
        },
        SET_PRODUCT_REVIEW_DATA(state, data) {
            state.productReview = data;
        },
        SET_PRODUCT_REVIEW_LOADING(state ,data ){
            state.reviewLoading = data;
        },
        SET_PAGINATION(state, page) {
            state.pagination = page
        },
        SET_ADD_TO_CART_LOADING(state, loading) {
            state.addToCartLoading = loading;
        },
    },
    actions: {
        async fetchProductReview({commit}, {product_id, page_number}) {
            // const {product_id, page_number} = payload;
            const url = `/api/Product/Review/${product_id}?page=${page_number}`;
            try {
                commit('SET_PRODUCT_REVIEW_LOADING', true);
                let response = await axios.get(url);
                commit('SET_PRODUCT_REVIEW_DATA', response.data);
                // console.log(response.data);
                commit('SET_PAGINATION', response.data);

            } catch (error) {
                console.log(error);
            } finally {
                commit('SET_PRODUCT_REVIEW_LOADING', false);
            }
        },

        async PostProductReview({ commit }, formData) {
            const url = '/api/post-product-review';
            const token = localStorage.getItem('token');
            try {
                const response = await axios.post(url, formData, {
                    headers: { Authorization: `Bearer ${token}` },
                });
                return response; // Return success message or response
            } catch (error) {
                console.error(error.response);
                throw error; // Rethrow to handle in the component
            }
        },

        async fetchSingleProducts({ commit }, id) {
            const url = `/api/single/product/${id}`;
            try {
                commit('SET_PRODUCT_SHIMMER', true);
                let response = await axios.get(url);
                commit('SET_PRODUCT_DATA', response.data);
                commit('SET_PRODUCT_SHIMMER', false);
            } catch (error) {
                console.log(error);
            }
        },

        async addToCartState({commit},{payload}){

            try {
                let product = payload.product;
                let qty = payload.quantity;
                let size = payload.size;
                let color = payload.color;
                let cart_business_id = localStorage.getItem('cart_business_id');
                console.log(cart_business_id);
                if (!cart_business_id) {
                    cart_business_id = product.business_id;
                    localStorage.setItem('cart_business_id', cart_business_id);
                }

                if (product && cart_business_id == product.business_id) {
                    commit('SET_ADD_TO_CART_LOADING' ,true);
                // Ensure payload structure matches the backend expectations
                let response = await axios.post('/api/add-to-cart', {
                    'product': product, // Check if 'product' key is expected by your backend
                    'quantity': qty,
                    'size' : size,
                    'color' : color
                });
                console.log(response.data);
                commit('SET_ADD_TO_CART_LOADING' ,false);
                return response;
                }else{
                    if (!product) {
                        toast.error('Invalid product');
                    } else {
                        const errorMessage = 'You already have items in the cart from a different business. ' +
                            'Please clear your cart before making another purchase.';
                        toast.error(errorMessage);
                    }
                }


            }catch (e){

            }
        },

    },
    getters: {
        showcolors(state) {
            try {
                // Ensure `state.products` exists
                if (!state.products || !state.products.color) return [];

                // Check if `state.products.colors` is already an array
                if (Array.isArray(state.products.color)) {
                    return state.products.color; // Return as is if it's already an array
                }

                // Ensure it's a string before parsing
                if (typeof state.products.color === 'string') {
                    return JSON.parse(state.products.color);
                }

                return []; // Return an empty array if `colors` is neither a string nor an array
            } catch (error) {
                console.error("Error parsing colors:", error);
                return []; // Return an empty array if parsing fails
            }
        }
    }


};

export default productModule;
